/** Get one tenant by ID */
export const tenantGetSpec = {
    uri: '/t/[tenant]',
    method: 'GET',
};
